/**
 * Query and mutation presets for offline-first architecture.
 *
 * Every query picks DURABLE or LIVE. Every judge mutation uses OFFLINE_MUTATION.
 * This ensures consistent behavior without ad-hoc config per hook.
 */

/** Survives offline. Persisted to IndexedDB. Freshness driven by SSE invalidation. */
export const DURABLE_QUERY = {
  staleTime: Infinity,
  gcTime: 24 * 60 * 60 * 1000, // 24h
} as const

/** Real-time, always fresh. Not critical for offline. Used by admin dashboards. */
export const LIVE_QUERY = {
  staleTime: 0,
  gcTime: 5 * 60 * 1000, // 5m
} as const

/** Judge scoring mutations. Queues when offline, retries a few times, then relies on sync engine. */
export const OFFLINE_MUTATION = {
  networkMode: 'offlineFirst' as const,
  retry: 3,
  retryDelay: 1000,
} as const
